module.exports = __webpack_public_path__ + "static/web_logo-c6c0d7319b2da3b17fbd2c719fc1441f.png";